import { fmtTL, fmtNum, fmtPct, fmtDate, fmtMonthYear } from "@/lib/format";

// PDF için özel, kurumsal görünümlü şablon (ekran dışında render edilir).
export function PdfDocument({ plan, summary, rows, labels }) {
  const today = new Date();

  let prevCum = 0;
  const displayAmounts = rows.map((r) => {
    if (r.cumulative === null) return r.amount;
    const cur = Math.round(r.cumulative);
    const amt = cur - prevCum;
    prevCum = cur;
    return amt;
  });

  const summaryItems = [
    [labels.financing, fmtTL(summary.financingAmount)],
    ["Organizasyon Bedeli", fmtTL(summary.organizationFee)],
    [labels.downPayment, fmtTL(summary.downPayment)],
    ["Peşinat Oranı", fmtPct(summary.downPaymentRate)],
    [
      "Teslim Tarihi",
      summary.deliveryDate ? fmtMonthYear(summary.deliveryDate) : "Ulaşılamıyor",
    ],
    ["Teslim Hedefi (%" + summary.deliveryTargetRate + ")", fmtTL(summary.deliveryTargetAmount)],
    ["Teslime Kadar Kalan", fmtTL(summary.requiredPreDelivery)],
    ["Min. Aylık Ödeme", fmtTL(summary.minimumMonthly)],
    ["Toplam Vade", `${summary.termMonths} Ay`],
    ["Teslim Sonrası Kalan", fmtTL(summary.teslimSonrasiKalan)],
  ];

  const wrap = {
    position: "fixed",
    left: "-10000px",
    top: 0,
    width: "794px",
    background: "#ffffff",
    color: "#18181b",
    fontFamily: "'Inter', sans-serif",
    padding: "36px 40px",
    boxSizing: "border-box",
  };

  return (
    <div id="pdf-document" style={wrap} aria-hidden="true">
      {/* Üst başlık + logo */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "2px solid #1aa0dd",
          paddingBottom: "16px",
        }}
      >
        <img src="/berkanevim-logo.webp" alt="BerkanEvim" style={{ height: "46px" }} />
        <div style={{ textAlign: "right", fontSize: "11px", color: "#71717a" }}>
          <div>Oluşturma Tarihi: {fmtDate(today)}</div>
          <div style={{ marginTop: "2px" }}>berkanevim.com</div>
        </div>
      </div>

      {/* Başlık */}
      <div style={{ marginTop: "22px" }}>
        <div
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "22px",
            fontWeight: 600,
            letterSpacing: "-0.02em",
          }}
        >
          {labels.name} Ödeme Planı
        </div>
        {plan.name ? (
          <div style={{ fontSize: "13px", color: "#71717a", marginTop: "3px" }}>
            {plan.name}
          </div>
        ) : null}
      </div>

      {/* Plan özeti */}
      <div
        style={{
          marginTop: "18px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "10px 28px",
        }}
      >
        {summaryItems.map(([label, value], i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #f0f0f1",
              paddingBottom: "7px",
            }}
          >
            <span style={{ fontSize: "12px", color: "#71717a" }}>{label}</span>
            <span style={{ fontSize: "12px", fontWeight: 600 }}>{value}</span>
          </div>
        ))}
      </div>

      {/* Ödeme planı tablosu */}
      <div
        style={{
          marginTop: "26px",
          fontFamily: "'Outfit', sans-serif",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        Ödeme Planı
      </div>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "10px",
          fontSize: "11px",
        }}
      >
        <thead>
          <tr style={{ background: "#18181b", color: "#ffffff" }}>
            {["Dönem", "Taksit Tarihi", "Aylık Ödeme", "Toplam Ödeme", "Kalan Borç", "Ödeme Türü"].map(
              (h, i) => (
                <th
                  key={i}
                  style={{
                    textAlign: i >= 2 && i <= 4 ? "right" : "left",
                    padding: "7px 8px",
                    fontWeight: 500,
                  }}
                >
                  {h}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr
              key={i}
              style={{
                background: r.isDeliveryMonth ? "#ffe9ea" : i % 2 ? "#fafafa" : "#ffffff",
                borderLeft: r.isDeliveryMonth ? "3px solid #FF5A5F" : "none",
              }}
            >
              <td style={{ padding: "6px 8px" }}>
                {r.period}
                {r.isDeliveryMonth ? (
                  <span style={{ color: "#FF5A5F", fontWeight: 700 }}> · Teslim</span>
                ) : null}
              </td>
              <td style={{ padding: "6px 8px", color: "#52525b" }}>{fmtDate(r.date)}</td>
              <td style={{ padding: "6px 8px", textAlign: "right", fontWeight: 600 }}>
                {fmtNum(displayAmounts[i])}
              </td>
              <td style={{ padding: "6px 8px", textAlign: "right", color: "#52525b" }}>
                {r.cumulative === null ? "—" : fmtNum(r.cumulative)}
              </td>
              <td style={{ padding: "6px 8px", textAlign: "right", fontWeight: 600 }}>
                {fmtNum(r.remaining)}
              </td>
              <td style={{ padding: "6px 8px", color: "#52525b" }}>{r.paymentType}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          marginTop: "18px",
          paddingTop: "12px",
          borderTop: "1px solid #f0f0f1",
          fontSize: "10px",
          color: "#a1a1aa",
          textAlign: "center",
        }}
      >
        Bu belge BerkanEvim Hesaplama Aracı ile oluşturulmuştur. Bilgilendirme amaçlıdır.
      </div>
    </div>
  );
}
